var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.displayCurrentDateTime)?_c('div',{staticClass:"calendar-content-current-datetime",style:('left: ' + _vm.currentDateTimeLeft + ';')}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }